import { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import moment from "moment";
import md5 from "md5";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants - Functions
import { WEB_SERVICE_MIMS, pathHomePage, project, pathologies, applications } from "../../config/constants";
import { passwordValidation, isValidDate, isValidBirthdate, parsedDate, HeightValidation, isLessThanToday } from "../../config/functions";
import {
  isPhraseProjectHospital,
  isNestProjectHospital,
  isRGSICUProjectHospital,
  isAISNProjectHospital,
} from "../../config/projectFunctions";
// Components
import Axios from "../../config/axios";
import { Form } from "./styles";
import Title from "../title";
import PersonalInformation from "./sections/personalInformation";
import Pathology from "./sections/pathology";
import Training from "./sections/training";
import Terms from "./sections/terms";
import Apps from "./sections/apps";
import Footer from "./sections/footer";

const AddPatient = () => {
  const clinicianData = useSelector(({ clinician }) => clinician.data);
  const [hospitalClinicians, setHospitalClinicians] = useState([]);
  const [hospitalIsPartOfAProject, setHospitalIsPartOfAProject] = useState(false);
  const [isAISNHospital, setIsAISNHospital] = useState(false);
  // Personal information
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [clinicianId, setClinicianId] = useState(useSelector(({ clinician }) => clinician.data.CLINICIAN_ID));
  const [aisnGroup, setAisnGroup] = useState(clinicianData?.AISN_GROUP === "RGS+AI" ? "RGS+AI" : "");
  const [startingDate, setStartingDate] = useState("");
  const [gender, setGender] = useState("");
  const [skinColor, setSkinColor] = useState("D09C80");
  const [height, setHeight] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [civilStatus, setCivilStatus] = useState("");
  const [homeSupport, setHomeSupport] = useState("");
  const [education, setEducation] = useState("");
  const [work, setWork] = useState("");
  const [gameExperience, setGameExperience] = useState("");
  const [computerExperience, setComputerExperience] = useState("");
  const [otherInfo, setOtherInfo] = useState("");
  // Pathology
  const [pathology, setPathology] = useState(project === "strack" ? pathologies.strokeId : "");
  const [strokeSide, setStrokeSide] = useState("");
  const [strokeType, setStrokeType] = useState("");
  const [strokeLocation, setStrokeLocation] = useState("");
  const [dateOfStroke, setDateOfStroke] = useState("");
  const [hasHeminegligence, setHasHeminegligence] = useState(0);
  const [pareticSide, setPareticSide] = useState("LEFT");
  const [comorbidity, setComorbidity] = useState("");
  // Training
  const [upperExtremityToTrain, setUpperExtremityToTrain] = useState("BOTH");
  const [handRaisingCapacity, setHandRaisingCapacity] = useState("NONE");
  const [cognitiveFunctionLevel, setCognitiveFunctionLevel] = useState("LOW");

  const [terms, setTerms] = useState(false);
  const [redirect, setRedirect] = useState(false);
  let appsArray = [];
  // handle errors
  const [loginError, setLoginError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [aisnGroupError, setAisnGroupError] = useState(false);
  const [startingDateError, setStartingDateError] = useState(false);
  const [genderError, setGenderError] = useState(false);
  const [heightError, setHeightError] = useState(false);
  const [dateOfBirthError, setDateOfBirthError] = useState(false);
  const [civilStatusError, setCivilStatusError] = useState(false);
  const [homeSupportError, setHomeSupportError] = useState(false);
  const [educationError, setEducationError] = useState(false);
  const [workError, setWorkError] = useState(false);
  const [pathologyError, setPathologyError] = useState(false);
  const [strokeSideError, setStrokeSideError] = useState(false);
  const [strokeTypeError, setStrokeTypeError] = useState(false);
  const [strokeLocationError, setStrokeLocationError] = useState(false);
  const [dateOfStrokeError, setDateOfStrokeError] = useState(false);
  const [comorbidityError, setComorbidityError] = useState(false);
  const [termsError, setTermsError] = useState(false);

  const [showApps, setShowApps] = useState(false);
  const [t] = useTranslation("global");

  // Fetching hospital clinicians
  useEffect(() => {
    if (clinicianData?.HOSPITAL_ID) {
      Axios("get", `${WEB_SERVICE_MIMS}/hospitals/get-clinicians/${clinicianData.HOSPITAL_ID}`)
        .then(({ data }) => {
          setHospitalClinicians(data);
        })
        .catch((error) => {
          console.log("Get hospital clinicians: ", error);
        });
    }

    return () => {
      setHospitalClinicians([]);
    };
  }, [clinicianData.HOSPITAL_ID]);

  // Set projects flag
  useEffect(() => {
    const handleSetProjectFlags = async () => {
      const isPHRASEHospital = await isPhraseProjectHospital(clinicianData.HOSPITAL_NAME);
      const isNESTHospital = await isNestProjectHospital(clinicianData.HOSPITAL_NAME);
      const isRGSICUHospital = await isRGSICUProjectHospital(clinicianData.HOSPITAL_NAME);

      setHospitalIsPartOfAProject(isPHRASEHospital || isNESTHospital || isRGSICUHospital);

      const isAISNHospital = await isAISNProjectHospital(clinicianData.HOSPITAL_NAME);
      setIsAISNHospital(isAISNHospital);
      if (isAISNHospital) setPathology(pathologies.strokeId);
    };
    handleSetProjectFlags();

    return () => {
      setIsAISNHospital(false);
    };
  }, [clinicianData]);

  const handleShowApps = (e) => {
    e.preventDefault();
    if (!showApps) {
      if (
        login === "" ||
        gender === "" ||
        (project === "global" && height === "") ||
        pathology === "" ||
        dateOfBirth === "" ||
        (isAISNHospital &&
          (aisnGroup === "" ||
            startingDate === "" ||
            civilStatus === "" ||
            homeSupport === "" ||
            education === "" ||
            work === "" ||
            strokeSide === "" ||
            strokeType === "" ||
            strokeLocation === "" ||
            comorbidity === "")) ||
        skinColor === "" ||
        (Number(pathology) === pathologies.strokeId && dateOfStroke === "")
      ) {
        toast.error(t("emptyDataMessage"));
        if (login === "") setLoginError(true);
        if (!passwordValidation(password)) setPasswordError(true);
        if (aisnGroup === "") setAisnGroupError(true);
        if (startingDate === "") setStartingDateError(true);
        if (gender === "") setGenderError(true);
        if (height === "") setHeightError(true);
        if (dateOfBirth === "") setDateOfBirthError(true);
        if (civilStatus === "") setCivilStatusError(true);
        if (homeSupport === "") setHomeSupportError(true);
        if (education === "") setEducationError(true);
        if (work === "") setWorkError(true);
        if (pathology === "") setPathologyError(true);
        if (strokeSide === "") setStrokeSideError(true);
        if (strokeType === "") setStrokeTypeError(true);
        if (strokeLocation === "") setStrokeLocationError(true);
        if (comorbidity === "") setComorbidityError(true);
        if (Number(pathology) === pathologies.strokeId && dateOfStroke === "") setDateOfStrokeError(true);
        return;
      }

      if (login.length > 20) {
        setLoginError(true);
        toast.error(t("profileMessage_usernameMessage"));
        return;
      }

      if (!passwordValidation(password)) {
        setPasswordError(true);
        toast.error(t("profileMessage_passwordMessage"));
        return;
      }

      if (project === "global" && !HeightValidation(height)) {
        setHeightError(true);
        toast.error(t("profileMessage_heightMessage"));
        return;
      }

      if (!isValidBirthdate(dateOfBirth)) {
        toast.error(t("profileMessage_birthDateMessage"));
        setDateOfBirthError(true);
        return;
      }

      if (Number(pathology) === pathologies.strokeId && !isValidDate(dateOfStroke)) {
        toast.error(t("profileMessage_strokeDateMessage"));
        setDateOfStrokeError(true);
        return;
      }

      const parsedStartingDate = moment(startingDate).format("DD/MM/YYYY");
      if (isAISNHospital && (!moment(parsedStartingDate, "DD/MM/YYYY", true).isValid() || isLessThanToday(parsedStartingDate))) {
        toast.error(t("Enter a valid starting date"));
        setStartingDateError(true);
        return;
      }

      if (!terms) {
        toast.error(t("addPatient_conditionsMessage"));
        setTermsError(true);
        return;
      }
      if (!hospitalIsPartOfAProject || isAISNHospital) {
        handleSubmit();
      } else {
        setShowApps(true);
      }
    } else {
      setShowApps(false);
    }
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();

    if (!appsArray.length && !isAISNHospital && hospitalIsPartOfAProject) return toast.error(t("profileMessage_applicationsMessage"));

    let data = {
      HOSPITAL_ID: clinicianData.HOSPITAL_ID,
      PATIENT_USER: login,
      PASSWORD: md5(`${login}${password}`),
      GENDER: gender,
      SKIN_COLOR: skinColor,
      PTN_HEIGHT_CM: Number(height),
      BIRTH_DATE: moment(parsedDate(dateOfBirth)).format("YYYY/MM/DD"),
      VIDEOGAME_EXP: gameExperience === "" ? null : Number(gameExperience),
      COMPUTER_EXP: computerExperience === "" ? null : Number(computerExperience),
      COMMENTS: otherInfo === "" ? null : otherInfo,
      AFFECTATION_ID: Number(pathology),
      HAS_HEMINEGLIGENCE: hasHeminegligence,
      STROKE_DATE: Number(pathology) === pathologies.strokeId ? parsedDate(dateOfStroke) : new Date(),
      PARETIC_SIDE: Number(pathology) === pathologies.strokeId ? pareticSide : "NONE",
      UPPER_EXTREMITY_TO_TRAIN: upperExtremityToTrain,
      HAND_RAISING_CAPACITY: handRaisingCapacity,
      COGNITIVE_FUNCTION_LEVEL: cognitiveFunctionLevel,
      PATIENT_SOFTWARE: appsArray,
      isAISNHospital,
    };

    if (!hospitalIsPartOfAProject) {
      data.PATIENT_SOFTWARE = [applications.clinic.id, applications.plus.id];
    }

    if (isAISNHospital) {
      data.AISN_GROUP = aisnGroup;
      data.CIVIL_STATUS = civilStatus;
      data.HOME_SUPPORT = homeSupport;
      data.EDUCATION = education;
      data.WORK = work;
      data.STROKE_SIDE = strokeSide;
      data.STROKE_TYPE = strokeType;
      data.STROKE_LOCATION = strokeLocation;
      data.ROUTINE_STARTING_DATE = moment(startingDate).format("YYYY/MM/DD");
      data.COMORBIDITY = comorbidity;
      data.PATIENT_SOFTWARE = [applications.clinic.id, applications.plus.id, applications.wear.id];
    }

    Axios("post", `${WEB_SERVICE_MIMS}/patients/add/${clinicianId}`, data)
      .then(({ data }) => {
        if (data.patientAdded) {
          toast.success(t("addPatient_patientAddedMessage"));
          setRedirect(true);
        }
        if (data.duplicatedPatient) {
          setLoginError(true);
          setShowApps(false);
          toast.error(t("profileMessage_duplicatedUserMessage"));
        }
      })
      .catch((error) => {
        toast.error(t("sendDataErrorMessage"));
        console.log("endpoint to add patient", error);
      });
  };
  if (redirect) {
    return <Redirect to={`${pathHomePage}/home/${clinicianData.token}`} />;
  }

  return (
    <>
      <Title title={!showApps ? t("addPatient_title") : t("rgsPrescriptions_title")} marginBottom="10px" />
      <Form onSubmit={handleSubmit}>
        {!showApps ? (
          <>
            <PersonalInformation
              hospitalClinicians={hospitalClinicians}
              login={login}
              setLogin={setLogin}
              loginError={loginError}
              setLoginError={setLoginError}
              password={password}
              setPassword={setPassword}
              passwordError={passwordError}
              setPasswordError={setPasswordError}
              clinicianId={clinicianId}
              setClinicianId={setClinicianId}
              aisnGroup={aisnGroup}
              setAisnGroup={setAisnGroup}
              aisnGroupError={aisnGroupError}
              setAisnGroupError={setAisnGroupError}
              startingDate={startingDate}
              setStartingDate={setStartingDate}
              startingDateError={startingDateError}
              setStartingDateError={setStartingDateError}
              gender={gender}
              setGender={setGender}
              genderError={genderError}
              setGenderError={setGenderError}
              height={height}
              setHeight={setHeight}
              heightError={heightError}
              setHeightError={setHeightError}
              dateOfBirth={dateOfBirth}
              setDateOfBirth={setDateOfBirth}
              dateOfBirthError={dateOfBirthError}
              setDateOfBirthError={setDateOfBirthError}
              civilStatus={civilStatus}
              setCivilStatus={setCivilStatus}
              civilStatusError={civilStatusError}
              setCivilStatusError={setCivilStatusError}
              homeSupport={homeSupport}
              setHomeSupport={setHomeSupport}
              homeSupportError={homeSupportError}
              setHomeSupportError={setHomeSupportError}
              education={education}
              setEducation={setEducation}
              educationError={educationError}
              setEducationError={setEducationError}
              work={work}
              setWork={setWork}
              workError={workError}
              setWorkError={setWorkError}
              gameExperience={gameExperience}
              setGameExperience={setGameExperience}
              computerExperience={computerExperience}
              setComputerExperience={setComputerExperience}
              otherInfo={otherInfo}
              setOtherInfo={setOtherInfo}
              skinColor={skinColor}
              setSkinColor={setSkinColor}
            />
            <Pathology
              pathology={pathology}
              setPathology={setPathology}
              pathologyError={pathologyError}
              setPathologyError={setPathologyError}
              strokeSide={strokeSide}
              setStrokeSide={setStrokeSide}
              strokeSideError={strokeSideError}
              setStrokeSideError={setStrokeSideError}
              strokeType={strokeType}
              setStrokeType={setStrokeType}
              strokeTypeError={strokeTypeError}
              setStrokeTypeError={setStrokeTypeError}
              strokeLocation={strokeLocation}
              setStrokeLocation={setStrokeLocation}
              strokeLocationError={strokeLocationError}
              setStrokeLocationError={setStrokeLocationError}
              dateOfStroke={dateOfStroke}
              setDateOfStroke={setDateOfStroke}
              dateOfStrokeError={dateOfStrokeError}
              setDateOfStrokeError={setDateOfStrokeError}
              hasHeminegligence={hasHeminegligence}
              setHasHeminegligence={setHasHeminegligence}
              pareticSide={pareticSide}
              setPareticSide={setPareticSide}
              comorbidity={comorbidity}
              setComorbidity={setComorbidity}
              comorbidityError={comorbidityError}
              setComorbidityError={setComorbidityError}
            />
            <Training
              upperExtremityToTrain={upperExtremityToTrain}
              setUpperExtremityToTrain={setUpperExtremityToTrain}
              handRaisingCapacity={handRaisingCapacity}
              setHandRaisingCapacity={setHandRaisingCapacity}
              cognitiveFunctionLevel={cognitiveFunctionLevel}
              setCognitiveFunctionLevel={setCognitiveFunctionLevel}
            />
            <Terms terms={terms} setTerms={setTerms} termsError={termsError} setTermsError={setTermsError} />
          </>
        ) : (
          <Apps appsArray={appsArray} />
        )}
        <Footer handleSubmit={handleSubmit} handleShowApps={handleShowApps} showApps={showApps} />
      </Form>
    </>
  );
};

export default AddPatient;
